import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to handle data refresh on page navigation
 * Simplified approach to avoid infinite loops
 */
export const usePageNavigationSync = () => {
  const location = useLocation();
  const lastPathRef = useRef<string>('');

  useEffect(() => {
    const currentPath = location.pathname;

    // Only log navigation changes, don't trigger data refresh
    // The individual pages will handle their own data loading
    if (currentPath !== lastPathRef.current) {
      lastPathRef.current = currentPath;
    }
  }, [location.pathname]);

  return null; // This hook only provides side effects
};